import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const Under40IconGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('#933EE5', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M10.0963 3.94297L6.79072 9.6164C6.59784 9.94745 6.11957 9.94745 5.92668 9.6164L2.62109 3.94297C2.42688 3.60964 2.66733 3.19126 3.05311 3.19126L9.6643 3.19126C10.0501 3.19126 10.2905 3.60964 10.0963 3.94297Z"
        fill={strokeColor}
        stroke={strokeColor}
      />
      <path
        d="M10.2896 1.31592L2.42773 1.31592"
        stroke={strokeColor}
        strokeLinecap="round"
      />
    </g>
  );
};

export const Under40IconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <Under40IconGroup {...props} />
    </svg>
  );
};
